import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Register.css";
import { toast } from "react-toastify";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !mobile || password.length < 6) {
      toast.warn("⚠️ Please fill all fields correctly");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("❌ Passwords do not match");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}customer_register`;
    
    console.log("API URL:", apiUrl);
    console.log("Submitting registration for:", email);

    const formData = new FormData();
    formData.append("first_name", name);
    formData.append("last_name", "");
    formData.append("email", email);
    formData.append("mobile_number", mobile);
    formData.append("password", password);
    formData.append("gender", "1");
    formData.append("dob", "2003-08-24");

    setIsLoading(true);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      console.log("Response status:", response.status);

      const data = await response.json();
      console.log("Response data:", data);

      if (response.ok && data.api_success) {
        localStorage.setItem("auth_token", data.token);
        localStorage.setItem("customer_id", data.customer.customer_id);
        localStorage.setItem("first_name", data.customer.first_name);
        localStorage.setItem("email", data.customer.email);
        localStorage.setItem("mobile_number", data.customer.mobile_number);

        toast.success("🎉 Registration Successful!", {
          onClose: () => navigate("/login"),
          autoClose: 2000,
        });
      } else {
        toast.error(`❌ ${data.message || "Registration failed"}`);
      }
    } catch (error) {
      console.error("Registration error:", error);
      toast.error(`🚨 Network error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="register-wrapper">
      <div className="register-card">
        <h1 className="register-title">Create an Account</h1>
        <p className="register-subtitle">
          Join us by filling in the information below.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="text"
            placeholder="Mobile Number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Signing up..." : "Sign Up"}
          </button>
        </form>
        <p className="login-link">
          Already have an account?{" "}
          <span onClick={() => navigate("/login")}>Login</span>
        </p>
      </div>
     
    </div>
  );
};

export default Register;